import React from 'react';
import { Shimmer } from '../Shimmer/Shimmer';
import { SegmentedControlShell } from './SegmentedControl.styles';
import { MarginProps } from '../../../theme/styledProps';

export const SegmentedControlLoading: React.FC<MarginProps> = props => {
  return (
    <SegmentedControlShell {...props}>
      <Shimmer width="100%" height={20} />
    </SegmentedControlShell>
  );
};
